import { strVal } from '../../../modules/Utils'
import ClientModal from '../../../components/Sales/Client/ClientModal'
import React, { Fragment } from 'react'
import { Button, Descriptions, Row } from 'antd'
import Status from '../../../elements/Status'

function ClientDetails(props) {
  const { client, onEdit } = props

  return (
    <Fragment>
      <Row style={{ marginTop: 20, marginLeft: 20 }}>
        <Descriptions bordered column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}>
          <Descriptions.Item label="Status">
            <Status value={client.status} />
          </Descriptions.Item>
          <Descriptions.Item label="Location">{client.location}</Descriptions.Item>
          <Descriptions.Item label="Partner Group">{strVal(client, 'partnerGroup.group', 'N/A')}</Descriptions.Item>
          <Descriptions.Item label="Tax Registration">{client.taxRegistration || 'N/A'}</Descriptions.Item>
        </Descriptions>
      </Row>
      <Row style={{ marginTop: 20, marginLeft: 20 }}>
        <Button onClick={onEdit} type="dashed" icon="user-add">
          Update Client
        </Button>
        <ClientModal {...props} />
      </Row>
    </Fragment>
  )
}

export default ClientDetails
